import {
  ChildCare,
  Dashboard,
  DevicesOther,
  DirectionsCar,
  Engineering,
  Group,
  Inventory,
  Route,
  SafetyCheck,
  SupervisedUserCircle,
  Troubleshoot,
  List,
  EmojiTransportation,
  DirectionsBus,
  EventSeat,
  CreditScore,
  TransferWithinAStation,
  AirportShuttle,
  LocalGasStation,
  CallSplit,
  LocationSearching,
  LegendToggle,
  CompassCalibration,
  PersonPinCircleOutlined,
} from '@mui/icons-material';
import { useBoundStore } from '../../../stores';
import { icon } from 'leaflet';

function Items() {
  const textPool = useBoundStore((state) => state.textPool);

  const appInstance = 'amir-al0';

  const items = [
    {
      id: 0,
      parent: textPool['ÜRÜNLER'],
      to: '/',
      child: [],
      icon: <Inventory />,
    },
    {
      id: 1,
      parent: textPool['KAVİ'],
      icon: <SafetyCheck />,
      to: '/kavi/dashboard',
      child: [
        {
          id: 0,
          to: '/kavi/dashboard',
          name: textPool['Dashboard'],
          icon: <Dashboard />,
        },
        {
          id: 1,
          to: '/kavi/transportation-safety-reports',
          name: textPool['Görev Güvenlik Raporları'],

          icon: <EventSeat />,
        },
        {
          id: 2,
          to: '/kavi/vehicle-safety-reports',
          name: textPool['Araç Güvenlik Raporları'],

          icon: <DirectionsBus />,
        },
        {
          id: 3,
          to: '/kavi/fleet-safety-reports',
          name: textPool['Filo Güvenlik Raporları'],

          icon: <EmojiTransportation />,
        },
      ],
    },
  ];

  let ctr = -1;
  const filteredItems = items
    .map((item) => {
      // Eğer öğe instance'a göre görünmüyorsa null döndür
      if (!item.instanceCanView || item.instanceCanView.includes(appInstance)) {
        ctr++;
        return {
          ...item,
          id: ctr, // Yeniden ID'leme
        };
      }
      return null;
    })
    .filter(Boolean); // null olanları filtrele

  return items;
}
export { Items as items };
